import React from 'react';
import calculateTotalTime from './calculateTotalTaskTime';
import GradeBanner from './GradeBanner';

// These are the expected max times for the tasks in the grade.
const expectedTimes = {
    "0": 1200,
    "1": 1260,
    "2": 900,
    "3": 900,
    "4": 900,
    "5": 900,
    "6": 900,
};

const TaskConfigurationBanners = ({ configState, taskFilter }) => {
    // Filter the tasks based on the taskFilter
    const tasksInSelectedAssessmentMode = configState.filter((task) => taskFilter.includes(task.name));

    return (
        <div>
            {Object.keys(expectedTimes).map((grade) => {
                const totalTime = calculateTotalTime(tasksInSelectedAssessmentMode, grade);
                const expectedTime = expectedTimes[grade];
                return (
                    <GradeBanner
                        key={grade}
                        grade={grade}
                        totalTime={totalTime}
                        expectedTime={expectedTime}
                    />
                );
            })}
        </div>
    );
};

export default TaskConfigurationBanners
